"use strict";
exports.__esModule = true;
var classNames = function () {
    var classes = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        classes[_i] = arguments[_i];
    }
    return classes.filter(Boolean).join(' ');
};
exports["default"] = classNames;
//# sourceMappingURL=class-names.js.map